import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/BillOperation";

export const GetPayTypes = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetPayTypes`, options);

export const GetPaymentTypes = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetPaymentTypes`, options);

export const GetDiscountTypes = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetDiscountTypes`, options);

export const GetSpecialDiscounts = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSpecialDiscounts`, options);

export const GetSpecialDiscountTotalPrice = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSpecialDiscountTotalPrice`, options);

export const GetInstallmentOptions = () =>
  GENERATE_URL(`${PREFIX_URL}/GetInstallmentOptions`);

export const PreviewPaymentPlan = () =>
  GENERATE_URL(`${PREFIX_URL}/PreviewPaymentPlan`);

export const CreateOrder = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CreateOrder`, options);

export default {
  GetPayTypes,
  GetPaymentTypes,
  GetDiscountTypes,
  GetSpecialDiscounts,
  GetSpecialDiscountTotalPrice,
  GetInstallmentOptions,
  PreviewPaymentPlan,
  CreateOrder,
};
